import { CalendarInfo, CreateTask, Task, TaskFilters, UpdateTaskRequest } from "../../types/task";
import { apiSlice } from "../baseQuery";
import { EndpointTags, TaskEndpointTags } from "../utils";

const BASE_URL = "/api/task";

export const tareaApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        getTasks: build.query<CalendarInfo, TaskFilters>({
            query: (request: TaskFilters) => {
                const queryString = new URLSearchParams({
                    empresaId: request.empresaId 
                        ? request.empresaId.toString() 
                        : "",
                    terminada: request.terminada != undefined 
                        ? request.terminada ? "true" : "false" : "",
                    formatoFecha: request.formatoFecha ?? ""
                });

                return BASE_URL + `?${queryString}`;
            },
            keepUnusedDataFor: 0,
            providesTags: [TaskEndpointTags.GET_TASKS]
        }),
        getTaskById: build.query<Task, number>({
            query: (taskId: number) => BASE_URL + `/${taskId}`,
            providesTags: [TaskEndpointTags.GET_TASK_BY_ID],
            keepUnusedDataFor: 0
        }),
        createTask: build.mutation<void, CreateTask>({
            query: (task: CreateTask) =>({
                url: BASE_URL,
                method: "POST",
                body: {...task},
            }),
            invalidatesTags: [TaskEndpointTags.GET_TASKS],
        }),
        updateTaskStatus: build.mutation<void, { taskId: number; terminada: boolean }>({
            query: (request: { taskId: number; terminada: boolean }) => {
                const queryString = new URLSearchParams({ terminada: request.terminada ? "true" : "false" })
                return {
                    url: BASE_URL + `/${request.taskId}/change-status?${queryString}`,
                    method: "POST",
                }
            },
            invalidatesTags: ["getTaskById"],
        }),
        updateTask: build.mutation<void, UpdateTaskRequest>({
            query: (request: UpdateTaskRequest) => ({
                url: BASE_URL + `/${request.id}`,
                method: "PUT",
                body: {
                    titulo: request.titulo,
                    texto: request.texto,
                    recordatorioActivado: request.recordatorioActivado,
                }
            }),
            invalidatesTags: [EndpointTags.GET_TASKS],
        })
    })
})

export const { 
    useGetTasksQuery,
    useGetTaskByIdQuery,
    useCreateTaskMutation,
    useUpdateTaskStatusMutation,
    useUpdateTaskMutation,
} = tareaApi;